import ahaGpt from './aha-gpt.module'
import aiChatbot from './ai-chatbot.module'

export default {
  ahaGpt,
  aiChatbot,
}
